import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=1459d1e7&scoped=true&"
import script from "./MyDialog.vue?vue&type=script&lang=js&"
export * from "./MyDialog.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/components/dialog/MyDialog.css?vue&type=style&index=0&id=1459d1e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459d1e7",
  null
  
)

export default component.exports